import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const manualAccountAdjustmentDirectionEnum = createEnum({
    INCREASE_EXPENSE: ['increase_expense', '增加费用', 'orange'],
    DECREASE_EXPENSE: ['decrease_expense', '减少费用', 'green'],
});
export const MANUAL_ACCOUNT_ADJUSTMENT_DIRECTIONS = enumValues(manualAccountAdjustmentDirectionEnum);
export const MANUAL_ACCOUNT_ADJUSTMENT_DIRECTION_LABEL_MAP = enumLabelMap(manualAccountAdjustmentDirectionEnum);
//# sourceMappingURL=manual-account-adjustment.js.map